// extracted by mini-css-extract-plugin
export default {"bg":"modal_bg__Tf9Mf","modal":"modal_modal__e093m","modalContent":"modal_modalContent__vA2zy"};